const ENV = process.env.REACT_APP_ENV || 'development';
console.log('#####config_ENV:', ENV);
module.exports = require('./' + ENV + '.js');
